import { RedirectUrlComponent } from './redirect-url/redirect-url.component';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { NgZorroAntdModule, NzBreadCrumbModule, NzSelectModule } from 'ng-zorro-antd';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import {CommonModule} from '@angular/common';

import {
    OpenAppComponent,
    VerifyPhoneComponent,
    OtpComponent,
    AuthenticationComponent,
    AuthenticationLoginComponent,
    AuthenticationRegisterComponent,
    ForgotPasswordComponent,
    BuyCardComponent,
    StepFirstComponent,
    ResultComponent
} from './index';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {LoadingComponent} from './loading/loading.component';
import {AlertComponent} from './alert/alert.component';
import {IvyCarouselModule} from './carousel/carousel.module';
import { ImageComponent } from './image/image.component';

@NgModule({
    declarations: [
        OpenAppComponent,
        VerifyPhoneComponent,
        OtpComponent,
        AuthenticationComponent,
        AuthenticationLoginComponent,
        AuthenticationRegisterComponent,
        ForgotPasswordComponent,
        BuyCardComponent,
        StepFirstComponent,
        ResultComponent,
        LoadingComponent,
        AlertComponent,
        RedirectUrlComponent,
        ImageComponent
    ],
    imports: [
        CommonModule,
        NgZorroAntdModule,
        ReactiveFormsModule,
        NzUploadModule,
        NzSelectModule,
        IonicModule,
        NzBreadCrumbModule,
        FormsModule,
        IvyCarouselModule
    ],
    exports: [
        OpenAppComponent,
        RedirectUrlComponent,
        VerifyPhoneComponent,
        OtpComponent,
        ImageComponent,
        AuthenticationComponent,
        AuthenticationLoginComponent,
        AuthenticationRegisterComponent,
        ForgotPasswordComponent,
        BuyCardComponent,
        StepFirstComponent,
        ResultComponent,
        LoadingComponent,
        AlertComponent,
        IvyCarouselModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class ShareModule {
}
